import { GitBookPage, Redirector } from "../../../../../tools/Redirector";
import { IListInMpNotificationController } from "./IListInMpNotificationController";
import { injectable } from "@launchtray/tsyringe-async";

@injectable()
export class ListInMpNotificationController implements IListInMpNotificationController {
    public openHowToExportInGameAssets(): void {
        Redirector.openGitBook(GitBookPage.EXPORT_IN_GAME_ASSETS);
    }
}
